'use client';
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive FormLabel (internal)
 * ROLE: implicit via <label> element | ARIA: for/htmlFor links to control
 * KEYBOARD: click delegates to associated control
 * FOCUS: not independently focusable
 * LIVE-REGION: none
 * PRM: no animation
 * FORCED-COLORS: color = CanvasText
 * RTL: direction-agnostic
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/practices/labels-embedded-in-landmarks/
 * SUBSTRATE: @radix-ui/react-label
 * INTERNAL: Not a public export. Consumed only by <Field label="..."> and <Field.Label>.
 *           Do NOT import this directly from app code.
 */
import * as RadixLabel from '@radix-ui/react-label';
import { VisuallyHidden } from '../../../VisuallyHidden/VisuallyHidden';
import { useUiStrings } from '../../i18n/UiStrings/UiStrings';
import styles from './FormLabel.module.css';
export function FormLabel({ id, htmlFor, children, required = false, announceRequired = false, }) {
    const strings = useUiStrings();
    return (_jsxs(RadixLabel.Root, { id: id, htmlFor: htmlFor, className: styles.label, children: [children, required && (_jsxs("span", { className: styles.required, "aria-hidden": "true", children: [' ', "*"] })), required && announceRequired ? _jsxs(VisuallyHidden, { children: [" ", strings.required] }) : null] }));
}
//# sourceMappingURL=FormLabel.js.map